import { Color } from '../common/index.ts';
import { createUseStyles } from 'react-jss';
import { IonIcon } from '@ionic/react';

const useStyles = createUseStyles({
    cardFooter: {
        width: '100%',
        height: '100%',
        padding: '5px 20px',
        lineHeight: 'normal'
    },

    // align message left and note right
    cardFooterInner: {
        width: '100%',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    }
});

export const CardFooter: React.FC<{size?: 'small' | 'large', message?: string, note?: string, color?: Color, clear?: boolean, icon?: string, onClick?: () => void, dataType?: string}> = ({ size = 'small', message = '', note = '', color = 'danger', clear, icon, onClick, dataType }) => {
    const classes = useStyles();
    const backgroundColor = clear ? 'white' : `rgba(var(--ion-color-${color}-rgb), 0.1)`;

    const handleClick = async (e: any) => {
        if (onClick) {
            e.stopPropagation();
            onClick();
        }
    };

    return (
        <>
            {(message || note) &&
                <div
                    data-type={dataType}
                    className={classes.cardFooter}
                    style={{
                        backgroundColor, color: `var(--ion-color-${color})`,
                        cursor: (onClick ? 'pointer' : undefined),
                        fontSize: (size === 'large' ? 14 : 11),
                        paddingBottom: (size === 'large' ? 8 : 6)
                    }}
                    onClick={handleClick}
                >
                    <span className={classes.cardFooterInner}>
                        <span>{message}</span>
                        <span>{note}</span>
                        {icon &&
                            <IonIcon color={color} style={{fontSize: 18, marginBottom: -2}} icon={icon} />
                        }
                    </span>
                </div>
            }
        </>
    );
};
